import HttpError from './HttpError';

export default class MembershipExistsError extends HttpError {}
